
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M22.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-20 0a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm4.654 6.645a.5.5 0 01.85.349v.999h1.5a.5.5 0 01.5.5v.998a.5.5 0 01-.5.5h-1.5v.998a.5.5 0 01-.86.36l-3-1.998a.508.508 0 010-.709zm9.704.003l3 2a.51.51 0 010 .71l-3 2a.5.5 0 01-.85-.36v-1h-1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.5v-1a.5.5 0 01.85-.35z"}})])
          )
        }
      }
    